import { SelectedTag } from "@src/api/review/types";

export const getConvertedReviewItemTagName = (tagName: SelectedTag) => {
  switch (tagName) {
    case "홀 투어 다녀왔어요":
      return "홀 투어 리뷰";
    case "여기서 결혼했어요":
      return "실제 예식 리뷰";
    case "하객 리뷰":
      return "하객 리뷰";
    case "상담 받았어요":
      return "상담 리뷰";
    case "계약했어요":
      return "계약 리뷰";
    default:
      return "";
  }
};
